import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart } from '@angular/router';
import { routeOverride } from '@df/core/meta/route-override.pipe';
import { IAddToBasketSuccessEventData } from '@df/session/api/basket/basket.service';
import { ModalRef, ModalState } from '@df/ui/modal/modal-ref';
import { ModalService } from '@df/ui/modal/modal.service';
import { Subscription } from 'rxjs/internal/Subscription';
import {
    BASKET_ADD_NOTICE_MODAL_UPDATE_EVENT_NAME,
    BasketAddNoticeModalComponent,
    IBasketAddNoticeModalData
} from './basket-add-notice-modal.component';
import { MinibasketComponentDef } from './deprecated/minibasket.component.def';

export const BASKET_ADD_NOTICE_DISALLOWED_LOCATIONS = ['/basket', '/checkout', '/success'];

@Component({
    selector: 'basket-add-notice',
    template: '',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketAddNoticeComponent extends MinibasketComponentDef implements OnInit, OnDestroy {
    readonly modalService = inject(ModalService);

    /**
     * Body class to set when open
     */
    override bodyClassName = ['basket.add.success'];

    /**
     * Hiding events
     */
    override hideEvents = ['basket-add-notice.close.request', NavigationStart];

    /**
     * Disallowed locations
     */
    override forbiddenLocations = BASKET_ADD_NOTICE_DISALLOWED_LOCATIONS.map(i => routeOverride(i));

    protected subscriptions = new Subscription();

    private lastRouterEvent?: NavigationEnd | NavigationStart | NavigationError | NavigationCancel;

    private lastModalRef?: ModalRef<BasketAddNoticeModalComponent>;

    override ngOnInit() {
        super.ngOnInit();
        this.subscriptions.add(
            this.app.meta.routerEvents.subscribe(event => {
                this.lastRouterEvent = event;
            })
        );
    }

    protected override subscribeToBasketAdd() {
        this.basketSuccessSubscription = this.basketService.subscribeToAddToBasketSuccess((data: IAddToBasketSuccessEventData) => {
                const request = data?.request?.products?.[0];

                if (request) {
                    const basketItem = this.basket.byAddToBasketRequest(request);

                    if (basketItem) {
                        this.showModal({ basketItem, request });
                    }
                }
        });
    }

    override ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.unsubscribe();
    }

    showModal(basketAddNoticeData: IBasketAddNoticeModalData) {
        if (this.router.url.indexOf('/checkout') !== 0 && !(this.lastRouterEvent instanceof NavigationStart)) {
            if (this.lastModalRef?.getState() === ModalState.OPEN) {
                this.app.events.broadcast(BASKET_ADD_NOTICE_MODAL_UPDATE_EVENT_NAME, basketAddNoticeData);
            } else {
                this.lastModalRef = this.modalService.openBottom(BasketAddNoticeModalComponent, {
                    width: '100%',
                    height: 'auto',
                    modalClass: 'p-a-0 modal-container-overflow-hidden',
                    data: basketAddNoticeData,
                    closeOnNavigation: true,
                    hasBackdrop: true,
                    backdropClass: 'no-off-click-cdk-overlay-dark-backdrop'
                });
            }
        }
    }

    // stop super show function
    override show() {}
}
